import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';

const hostname = process.env.REACT_APP_HOSTNAME;
const baseUrl = hostname
  ? new URL('api/v1', hostname.endsWith('/') ? hostname : `${hostname}/`).href
  : '/api/v1';

export const emptySplitApi = (reducerPath: string, tagTypes?: string[]) =>
  createApi({
    reducerPath,
    tagTypes: tagTypes || [],
    baseQuery: fetchBaseQuery({
      baseUrl,
    }),
    endpoints: () => ({}),
  });
